import { Link } from 'react-router-dom';
import Icon from './Icons';
import LinkSecao from './LinkSecao';
import servicos from '../data/servicos';
import { SLUG_BRASILIA } from '../seo';
import { site, praca, monograma, linkWhatsApp } from '../config';
import './Rodape.css';

const institucional = [
  { para: '/sobre', rotulo: 'O Advogado' },
  { para: '/contato', rotulo: 'Contato' },
  { para: `/${SLUG_BRASILIA}`, rotulo: `Advogado Criminalista em ${site.endereco.cidade}` },
];

export default function Rodape() {
  const ano = new Date().getFullYear();

  return (
    <footer className="rodape">
      <div className="container rodape__topo">
        <div className="rodape__marca">
          <span className="marca__monograma" aria-hidden="true">
            {monograma}
          </span>
          <p className="rodape__nome">{site.nome}</p>
          <p className="rodape__oab">
            {site.cargo} · {site.oab}
          </p>
          <p className="rodape__descricao">
            Advocacia criminal em todas as fases da persecução penal, para
            clientes de todos os estados. Base em {praca}, onde ficam o Superior
            Tribunal de Justiça e o Supremo Tribunal Federal.
          </p>

          {(site.instagram || site.linkedin) && (
            <div className="rodape__redes">
              {site.instagram && (
                <a
                  href={site.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <Icon name="instagram" size={19} />
                </a>
              )}
              {site.linkedin && (
                <a
                  href={site.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <Icon name="linkedin" size={19} />
                </a>
              )}
              <a
                href={linkWhatsApp()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <Icon name="whatsapp" size={19} />
              </a>
            </div>
          )}
        </div>

        <nav className="rodape__coluna" aria-label="Institucional">
          <h2>Escritório</h2>
          <ul>
            {institucional.map((item) => (
              <li key={item.para}>
                <Link to={item.para}>{item.rotulo}</Link>
              </li>
            ))}
            <li>
              <LinkSecao secao="atendimento">Como funciona</LinkSecao>
            </li>
            <li>
              <LinkSecao secao="duvidas">Dúvidas frequentes</LinkSecao>
            </li>
          </ul>
        </nav>

        <nav className="rodape__coluna rodape__coluna--areas" aria-label="Áreas de atuação">
          <h2>Áreas de Atuação</h2>
          <ul>
            {servicos.map((servico) => (
              <li key={servico.id}>
                <Link to={`/${servico.slug}`}>{servico.titulo}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="rodape__coluna">
          <h2>Contato</h2>
          <ul className="rodape__contato">
            <li>
              <Icon name="telefone" size={16} />
              <a href={`tel:${site.telefoneLink}`}>{site.telefone}</a>
            </li>
            <li>
              <Icon name="whatsapp" size={16} />
              <a href={linkWhatsApp()} target="_blank" rel="noopener noreferrer">
                {site.celular}
              </a>
            </li>
            <li>
              <Icon name="email" size={16} />
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </li>
            {/* Sem endereço: não há escritório aberto ao público. */}
            <li>
              <Icon name="local" size={16} />
              <span>
                Base em {praca} · atendimento em todo o Brasil
              </span>
            </li>
            <li>
              <Icon name="relogio" size={16} />
              <span>{site.horario}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="container rodape__aviso" id="privacidade">
        <p>
          <strong>Publicidade.</strong> Este site tem caráter exclusivamente
          informativo, em conformidade com o Código de Ética e Disciplina da OAB
          e com o Provimento nº 205/2021 do Conselho Federal da OAB. Não
          constitui oferta de serviços, captação de clientela, mercantilização
          da advocacia nem promessa de resultados. O conteúdo publicado não
          substitui a consulta a um profissional habilitado.
        </p>
        <p>
          <strong>Atendimento.</strong> O atendimento presencial ocorre no
          Distrito Federal, sempre com hora marcada. Para clientes de outros
          estados, a atuação é conduzida por videoconferência, com deslocamento
          presencial definido caso a caso e combinado por escrito antes da
          contratação.
        </p>
        <p>
          <strong>Privacidade.</strong> Os dados informados no formulário de
          contato são utilizados apenas para responder à solicitação, nos termos
          da Lei nº 13.709/2018 (LGPD). Não são compartilhados com terceiros nem
          usados para envio de comunicações não solicitadas. Para solicitar
          acesso, correção ou exclusão dos seus dados, escreva para{' '}
          <a href={`mailto:${site.email}`}>{site.email}</a>.
        </p>
      </div>

      <div className="rodape__base">
        <div className="container rodape__base-interno">
          <p>
            © {ano} {site.nome} — {site.oab}. Todos os direitos reservados.
          </p>
          <ul>
            <li>
              <LinkSecao secao="inicio">Voltar ao topo</LinkSecao>
            </li>
            <li>
              <a href="#privacidade">Privacidade e LGPD</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
